import React, { useState, useEffect } from 'react'
//active menu
import { activeMenu } from '../../../../../reducer/userReducer';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
const Content = () => {
    
    //active menu
    const dispatch = useDispatch();
    const activePath = "dashboard";
    // --- ส่วนการจัดการ Side Effect ---
    useEffect(() => {
        // เมื่อ Component ถูกโหลด จะทำการ Dispatch เพื่อตั้งค่าเมนูที่ Active ใน Redux Store
        if (dispatch) {
            dispatch(activeMenu(activePath));
        }
    },[dispatch])

    // --- 1. SET INITIAL STATES (ข้อมูลพื้นฐานสำหรับการคำนวณ) ---
    
    // สถานะสำหรับต้นทุนคงที่: ราคาซื้อ, ราคาขายต่อ, อายุการใช้งาน, และค่าใช้จ่ายรายปี
    const [fixedCosts, setFixedCosts] = useState({
        purchasePrice: 1000000, 
        resalePrice: 400000, 
        lifeTimeKm: 500000,
        insuranceYear: 20000, 
        taxActYear: 1500, 
        otherFixedYear: 5000
    });

    // สถานะสำหรับการบำรุงรักษา: ราคายาง, ระยะการเปลี่ยนยาง, ค่าเซอร์วิส, และรอบการเข้าศูนย์
    const [maintenance, setMaintenance] = useState({
        tireSetPrice: 22000, 
        tireLifeKm: 50000, 
        servicePrice: 3500, 
        serviceEvery: 10000
    });

    // สถานะข้อมูลเชื้อเพลิง: ราคาน้ำมันปัจจุบัน และอัตราการสิ้นเปลือง (กม./ลิตร)
    const [fuelData, setFuelData] = useState({
        fuelPrice: 35, 
        consumptionRate: 22
    });

    // สถานะข้อมูลการเดินทาง: ระยะทาง, ค่าจ้างคนขับ, ค่าทางด่วน และรูปแบบการเดินทาง (ไป-กลับ)
    const [trip, setTrip] = useState({
        distance: 90, 
        driverWage: 750, 
        tollFee: 0, 
        isRoundTrip: true
    });

    // --- 1.2 STATE สำหรับข้อมูลการจองและลูกค้า (ส่วนบันทึกรายละเอียดงาน) ---
    const [bookingInfo, setBookingInfo] = useState({
        origin: 'พะเยา',           // จุดเริ่มต้นเดินทาง
        destination: 'สนามบินเชียงราย',      // จุดหมายปลายทาง
        startDate: '',        // วันเวลาที่เริ่มออกเดินทาง
        endDate: '',          // วันเวลาที่จบงาน
        customerName: '',     // ชื่อผู้ติดต่อ/ลูกค้า
        customerPhone: '',    // เบอร์โทรศัพท์ลูกค้า
        driverName: '',       // ชื่อพนักงานขับรถ
        driverPhone: '',      // เบอร์โทรศัพท์พนักงานขับรถ
        customerPrice: '',    // ราคาเสนอขายที่แจ้งกับลูกค้า
        note: ''              // บันทึกช่วยจำอื่นๆ
    });

    // --- 2. CALCULATION LOGIC (ส่วนประมวลผลต้นทุน) ---

    // คำนวณต้นทุนน้ำมันต่อ 1 กิโลเมตร (ราคาน้ำมัน หารด้วย อัตราสิ้นเปลือง)
    const fuelCostKm = fuelData.consumptionRate > 0 ? fuelData.fuelPrice / fuelData.consumptionRate : 0;
    
    // คำนวณค่าเสื่อมราคารถต่อ 1 กิโลเมตร ( (ซื้อ-ขายต่อ) หารด้วย ระยะทางที่คาดว่าจะใช้ได้ตลอดอายุการใช้งาน )
    const deprPerKm = (fixedCosts.purchasePrice - fixedCosts.resalePrice) / fixedCosts.lifeTimeKm;
    
    // คำนวณต้นทุนยางต่อ 1 กิโลเมตร (ราคายางยกชุด หารด้วย ระยะทางที่ยางใช้งานได้)
    const tirePerKm = maintenance.tireSetPrice / maintenance.tireLifeKm;
    
    // คำนวณค่าซ่อมบำรุง/เช็คระยะต่อ 1 กิโลเมตร (ค่าบริการต่อครั้ง หารด้วย ระยะทางรอบการเข้าศูนย์)
    const servicePerKm = maintenance.servicePrice / maintenance.serviceEvery;
    
    // รวมค่าใช้จ่ายคงที่รายปี (ประกัน + ภาษี + อื่นๆ) เพื่อหาภาระค่าใช้จ่ายที่ไม่แปรผันตามระยะทาง
    const annualFixedTotal = fixedCosts.insuranceYear + fixedCosts.taxActYear + fixedCosts.otherFixedYear;
    
    // เฉลี่ยค่าใช้จ่ายคงที่ต่อวัน (สมมติวิ่งรถ 300 วันต่อปี เพื่อหาต้นทุนถือครองต่อวัน)
    const fixedCostPerDay = annualFixedTotal / 300;
    
    // คำนวณระยะทางรวมของทริป (ถ้าเลือกไป-กลับ ให้นำระยะทาง x 2)
    const totalDistance = trip.isRoundTrip ? trip.distance * 2 : trip.distance;
    
    // คำนวณค่าทางด่วนรวม (ถ้าเลือกไป-กลับ ให้นำค่าทางด่วน x 2)
    const totalTollFee = trip.isRoundTrip ? trip.tollFee * 2 : trip.tollFee;
    
    // รวมต้นทุนแปรผันทั้งหมดต่อกิโลเมตร (ค่าเสื่อม + ค่าเช็คระยะยาง + ค่าเซอร์วิส + ค่าน้ำมัน)
    const totalVariableCostPerKm = deprPerKm + tirePerKm + servicePerKm + fuelCostKm;
    
    // คำนวณต้นทุนรวมของทริปนี้ (ต้นทุนแปรผันตามกิโลเมตร + ค่าแรงคนขับ + ค่าทางด่วน + ค่าคงที่รายวัน 2 วันสำหรับเตรียมงานและเดินทาง)
    const tripTotalCost = (totalVariableCostPerKm * totalDistance) + trip.driverWage + totalTollFee + (fixedCostPerDay * 2);
    
    // คำนวณต้นทุนจริงเฉลี่ยต่อ 1 กิโลเมตรของทริปนี้ (ต้นทุนรวม หารด้วย ระยะทางรวม)
    const finalCostPerKm = totalDistance > 0 ? tripTotalCost / totalDistance : 0;

    // --- 3. LOGIC ตรวจสอบข้อมูลและการพิมพ์ ---

    // ✅ เพิ่ม errors state แทนการแตะ DOM
    const [errors, setErrors] = useState({
        origin: false,
        destination: false,
        startDate: false,
        endDate: false,
        customerName: false,
        customerPhone: false,
        driverName: false,
        driverPhone: false,
        customerPrice: false,
    });

    // ✅ validateAndPrint ใหม่ — ไม่แตะ DOM เลย
    const validateAndPrint = () => {
        // สร้าง object ตรวจสอบว่า field ไหนว่าง
        const newErrors = {
            origin:        bookingInfo.origin.trim() === "",
            destination:   bookingInfo.destination.trim() === "",
            startDate:     bookingInfo.startDate.trim() === "",
            endDate:       bookingInfo.endDate.trim() === "",
            customerName:  bookingInfo.customerName.trim() === "",
            customerPhone: bookingInfo.customerPhone.trim() === "",
            driverName:    bookingInfo.driverName.trim() === "",
            driverPhone:   bookingInfo.driverPhone.trim() === "",
            customerPrice: bookingInfo.customerPrice.trim() === "",
        };

        setErrors(newErrors);

        // ตรวจว่ามี error ไหม
        const hasError = Object.values(newErrors).some(v => v === true);

        if (hasError) {
            toast.error("โปรดระบุข้อมูลให้ครบ");
            window.scrollTo(0, 0);
            return;
        }

        window.print();
    };

    // ✅ helper function สำหรับ clear error ตอน user พิมพ์
    const clearError = (field) => {
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: false }));
        }
    };

    return (
        <main className="container-fluid p-4 bg-light min-vh-100 font-kanit">
            {/* CSS สำหรับควบคุม Layout เมื่อสั่งพิมพ์ (Hide UI elements during print) */}
            <style>
                {`
                    @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;700&display=swap');
                    @media print {
                        .shadow-none { display: none !important; }
                        .no-print { display: none !important; }
                        .print-only { display: block !important; }
                        body { background: white !important; font-family: 'Sarabun', sans-serif; }
                        .card { border: 1px solid #dee2e6 !important; box-shadow: none !important; }
                    }
                    .print-only { display: none; }
                    .form-label-bold { font-weight: 700; color: #495057; font-size: 0.85rem; }
                    .card-custom { border-radius: 12px; overflow: hidden; }
                    .input-custom:focus { border-color: #17a2b8; box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.25); }
                `}
            </style>

            {/* ส่วนหัวข้อหลัก (ซ่อนเมื่อพิมพ์) */}
            <header className="text-center mb-5 no-print">
                <h2 className="display-4 font-weight-bold text-dark">🚛 ระบบบริหารจัดการ และ คำนวณราคาค่าบริการขนส่ง</h2>
            </header>

            {/* --- ส่วนฟอร์มข้อมูลการจอง (Booking Details) --- */}
            <div className="card shadow-sm mb-4 border-0 card-custom no-print">
                <div className="card-header bg-white border-bottom py-3">
                    <h5 className="mb-0 text-info font-weight-bold">📝 รายละเอียดการจองและข้อมูลติดต่อ</h5>
                </div>
                <div className="card-body bg-white">
                    <div className="row">
                        {/* เส้นทาง */}
                        <div className="col-md-3 mb-3">
                            <label className="form-label-bold">📍 เส้นทาง (ต้นทาง - ปลายทาง)</label>

                            <input
                                type="text"
                                name="origin"
                                placeholder="ระบุต้นทาง"
                                value={bookingInfo.origin}
                                // ✅ className อ่านจาก errors state
                                className={`form-control mb-2 input-custom ${
                                    errors.origin ? 'is-invalid text-danger' : 
                                    bookingInfo.origin ? 'is-valid text-success' : ''
                                }`}
                                onChange={e => {
                                    setBookingInfo({...bookingInfo, origin: e.target.value});
                                    clearError('origin'); // ✅ clear error ทันทีที่พิมพ์
                                }}
                            />

                            <input
                                type="text"
                                name="destination"
                                placeholder="ระบุปลายทาง"
                                value={bookingInfo.destination}
                                className={`form-control input-custom ${
                                    errors.destination ? 'is-invalid text-danger' : 
                                    bookingInfo.destination ? 'is-valid text-success' : ''
                                }`}
                                onChange={e => {
                                    setBookingInfo({...bookingInfo, destination: e.target.value});
                                    clearError('destination');
                                }}
                            />
                        </div>

                        {/* กำหนดการ */}
                        <div className="col-md-3 mb-3">
                            <label className="form-label-bold">📅 กำหนดการ (ไป - กลับ)</label>
                            <input
                                type="datetime-local"
                                name="startDate"
                                value={bookingInfo.startDate}
                                className={`form-control mb-2 input-custom ${
                                    errors.startDate ? 'is-invalid' : 
                                    bookingInfo.startDate ? 'is-valid' : ''
                                }`}
                                onChange={e => {
                                    setBookingInfo({...bookingInfo, startDate: e.target.value});
                                    clearError('startDate');
                                }}
                            />

                            <input
                                type="datetime-local"
                                name="endDate"
                                value={bookingInfo.endDate}
                                className={`form-control input-custom ${
                                    errors.endDate ? 'is-invalid' : 
                                    bookingInfo.endDate ? 'is-valid' : ''
                                }`}
                                onChange={e => {
                                    setBookingInfo({...bookingInfo, endDate: e.target.value});
                                    clearError('endDate');
                                }}
                            />
                        </div>

                        {/* ข้อมูลลูกค้า */}
                        <div className="col-md-3 mb-3">
                            <label className="form-label-bold">👤 ข้อมูลลูกค้า</label>
                            <input
                                type="text"
                                name="customerName"
                                placeholder="ชื่อลูกค้า"
                                value={bookingInfo.customerName}
                                className={`form-control mb-2 input-custom ${
                                    errors.customerName ? 'is-invalid text-danger' : 
                                    bookingInfo.customerName ? 'is-valid text-success' : ''
                                }`}
                                onChange={e => {
                                    setBookingInfo({...bookingInfo, customerName: e.target.value});
                                    clearError('customerName');
                                }}
                            />

                            <input
                                type="text"
                                name="customerPhone"
                                placeholder="เบอร์โทรศัพท์"
                                value={bookingInfo.customerPhone}
                                className={`form-control input-custom ${
                                    errors.customerPhone ? 'is-invalid text-danger' : 
                                    bookingInfo.customerPhone ? 'is-valid text-success' : ''
                                }`}
                                onChange={e => {
                                    setBookingInfo({...bookingInfo, customerPhone: e.target.value});
                                    clearError('customerPhone');
                                }}
                            />
                        </div>

                        {/* ข้อมูลผู้ขับ */}
                        <div className="col-md-3 mb-3">
                            <label className="form-label-bold">👨‍✈️ ข้อมูลผู้ขับ</label>
                            <input
                                type="text"
                                name="driverName"
                                placeholder="ชื่อผู้ขับ"
                                value={bookingInfo.driverName}
                                className={`form-control mb-2 input-custom ${
                                    errors.driverName ? 'is-invalid text-danger' : 
                                    bookingInfo.driverName ? 'is-valid text-success' : ''
                                }`}
                                onChange={e => {
                                    setBookingInfo({...bookingInfo, driverName: e.target.value});
                                    clearError('driverName');
                                }}
                            />

                            <input
                                type="text"
                                name="driverPhone"
                                placeholder="เบอร์โทรศัพท์"
                                value={bookingInfo.driverPhone}
                                className={`form-control input-custom ${
                                    errors.driverPhone ? 'is-invalid text-danger' : 
                                    bookingInfo.driverPhone ? 'is-valid text-success' : ''
                                }`}
                                onChange={e => {
                                    setBookingInfo({...bookingInfo, driverPhone: e.target.value});
                                    clearError('driverPhone');
                                }}
                            />
                        </div>

                        {/* ราคาค่าบริการ */}
                        <div className="col-md-4 mb-3">
                            <label className="form-label-bold text-primary">💰 ราคาค่าบริการ (บาท)</label>
                            <input
                                type="text"
                                name="customerPrice"
                                placeholder="0.00"
                                value={bookingInfo.customerPrice}
                                className={`form-control form-control-lg font-weight-bold input-custom ${
                                    errors.customerPrice 
                                        ? 'is-invalid text-danger' 
                                        : 'border-primary text-primary'
                                }`}
                                onChange={e => {
                                    setBookingInfo({...bookingInfo, customerPrice: e.target.value});
                                    clearError('customerPrice');
                                }}
                            />                        
                        </div>

                        {/* หมายเหตุ (ไม่ validate) */}
                        <div className="col-md-8 mb-3">
                            <label className="form-label-bold">🔍 หมายเหตุเพิ่มเติม</label>
                            <textarea
                                className="form-control input-custom"
                                rows="1"
                                placeholder="ระบุรายละเอียดงานหรือข้อควรระวัง..."
                                value={bookingInfo.note}
                                onChange={e => setBookingInfo({...bookingInfo, note: e.target.value})}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* --- ส่วนตั้งค่าต้นทุน (Cost Settings) --- */}
            <div className="row no-print">
                {/* กลุ่มที่ 1: สินทรัพย์ */}
                <div className="col-lg-4">
                    <div className="card shadow-sm mb-4 border-0 card-custom">
                        <div className="card-header bg-dark text-white py-3">
                            <h6 className="mb-0 font-weight-bold"><i className="fas fa-car mr-2"></i>1. ต้นทุนคงที่ & ค่าเสื่อม</h6>
                        </div>
                        <div className="card-body">
                            <label className="form-label-bold">ราคารถ / ราคาขายต่อ (บาท)</label>
                            <div className="input-group mb-3">
                                <input type="text" className="form-control" placeholder="ราคาซื้อ" value={fixedCosts.purchasePrice} onChange={e => setFixedCosts({...fixedCosts, purchasePrice: +e.target.value})} />
                                <input type="text" className="form-control" placeholder="ราคาขาย" value={fixedCosts.resalePrice} onChange={e => setFixedCosts({...fixedCosts, resalePrice: +e.target.value})} />
                            </div>
                            <label className="form-label-bold">อายุการใช้งานทั้งหมด (กม.)</label>
                            <input type="text" className="form-control mb-3" value={fixedCosts.lifeTimeKm} onChange={e => setFixedCosts({...fixedCosts, lifeTimeKm: +e.target.value})} />
                            <hr />
                            <div className="row">
                                <div className="col-6 mb-2">
                                    <label className="form-label-bold">ประกันภัย/ปี</label>
                                    <input type="text" className="form-control" value={fixedCosts.insuranceYear} onChange={e => setFixedCosts({...fixedCosts, insuranceYear: +e.target.value})} />
                                </div>
                                <div className="col-6 mb-2">
                                    <label className="form-label-bold">ภาษี-พรบ./ปี</label>
                                    <input type="text" className="form-control" value={fixedCosts.taxActYear} onChange={e => setFixedCosts({...fixedCosts, taxActYear: +e.target.value})} />
                                </div>
                                <div className="col-12">
                                    <label className="form-label-bold">อื่นๆ/ปี</label>
                                    <input type="text" className="form-control" value={fixedCosts.otherFixedYear} onChange={e => setFixedCosts({...fixedCosts, otherFixedYear: +e.target.value})} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* กลุ่มที่ 2: เชื้อเพลิงและบำรุงรักษา */}
                <div className="col-lg-4">
                    <div className="card shadow-sm mb-4 border-0 card-custom">
                        <div className="card-header bg-primary text-white py-3">
                            <h6 className="mb-0 font-weight-bold"><i className="fas fa-gas-pump mr-2"></i>2. เชื้อเพลิง & บำรุงรักษา</h6>
                        </div>
                        <div className="card-body">
                            <div className="p-3 mb-4 rounded border-primary bg-light text-center shadow-sm">
                                <label className="form-label-bold text-primary mb-1">⛽ อัตราสิ้นเปลือง (กม./ลิตร)</label>
                                <input type="text" className="form-control form-control-lg text-primary text-center font-weight-bold" value={fuelData.consumptionRate} onChange={e => setFuelData({...fuelData, consumptionRate: +e.target.value})} />
                            </div>
                            <label className="form-label-bold">ราคาน้ำมันหน้าปั๊ม (บาท/ลิตร)</label>
                            <input type="text" className="form-control mb-3" value={fuelData.fuelPrice} onChange={e => setFuelData({...fuelData, fuelPrice: +e.target.value})} />
                            <label className="form-label-bold">ยาง: ราคายกชุด / อายุการใช้งาน (กม.)</label>
                            <div className="input-group mb-3">
                                <input type="text" className="form-control" value={maintenance.tireSetPrice} onChange={e => setMaintenance({...maintenance, tireSetPrice: +e.target.value})} />
                                <input type="text" className="form-control" value={maintenance.tireLifeKm} onChange={e => setMaintenance({...maintenance, tireLifeKm: +e.target.value})} />
                            </div>
                            <label className="form-label-bold">เซอร์วิส: ค่าใช้จ่าย / รอบ (กม.)</label>
                            <div className="input-group">
                                <input type="text" className="form-control" value={maintenance.servicePrice} onChange={e => setMaintenance({...maintenance, servicePrice: +e.target.value})} />
                                <input type="text" className="form-control" value={maintenance.serviceEvery} onChange={e => setMaintenance({...maintenance, serviceEvery: +e.target.value})} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* กลุ่มที่ 3: รายละเอียดทริป */}
                <div className="col-lg-4">
                    <div className="card shadow-sm mb-4 border-0 card-custom">
                        <div className="card-header bg-success text-white py-3">
                            <h6 className="mb-0 font-weight-bold"><i className="fas fa-route mr-2"></i>3. ข้อมูลเฉพาะทริปนี้</h6>
                        </div>
                        <div className="card-body">
                            <label className="form-label-bold">ระยะทางเที่ยวเดียว (กม.)</label>
                            <div className="input-group mb-3">
                                <input type="text" className="form-control form-control-lg font-weight-bold text-success" value={trip.distance} onChange={e => setTrip({...trip, distance: +e.target.value})} />
                                <div className="input-group-append"><span className="input-group-text bg-white">KM</span></div>
                            </div>
                            <label className="form-label-bold">ค่าแรงคนขับ (บาท)</label>
                            <input type="text" className="form-control mb-3" value={trip.driverWage} onChange={e => setTrip({...trip, driverWage: +e.target.value})} />
                            <label className="form-label-bold">ค่าทางด่วนต่อเที่ยว (บาท)</label>
                            <input type="text" className="form-control mb-3" value={trip.tollFee} onChange={e => setTrip({...trip, tollFee: +e.target.value})} />
                            
                            <div className="form-check mt-3 p-2 border rounded bg-light">
                                <input type="checkbox" className="form-check-input ml-1" checked={trip.isRoundTrip} onChange={e => setTrip({...trip, isRoundTrip: e.target.checked})} id="rtCheck" />
                                <label className="form-check-label ml-4" htmlFor="rtCheck">คิดไป-กลับ (รวม {totalDistance} กม.)</label>
                            </div>
                            <div className="text-center w-100">
                                <button className="btn btn-warning btn-lg mt-2 px-4 font-weight-bold shadow" onClick={validateAndPrint}>
                                    <i className="fas fa-print mr-2"></i> พิมพ์ใบสรุปงาน
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- ส่วนสรุปผล Dashboard (Cost Result) --- */}
            <div className="card shadow-lg border-0 bg-dark text-white p-4 card-custom mb-5 no-print">
                    <div className="row align-items-center">
                        <div className="col-md-4 text-center border-right border-secondary py-3">
                            <span className="text-uppercase small tracking-widest text-secondary font-weight-bold">ต้นทุนรวมทริปนี้</span>
                            <div className="display-4 font-weight-bold text-warning my-2">
                                {tripTotalCost.toLocaleString(undefined, {maximumFractionDigits: 0})} <small className="h4">฿</small>
                            </div>
                        </div>
                        <div className="col-md-4 px-5 py-3 border-right border-secondary">
                            <h6 className="text-secondary font-weight-bold mb-3 text-center">องค์ประกอบต้นทุน / กม.</h6>
                            <div className="d-flex justify-content-between mb-2">
                                <span>⛽ ค่าน้ำมัน:</span>
                                <span className="text-warning font-weight-bold">{fuelCostKm.toFixed(2)} ฿</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span>🔧 บำรุงรักษา & เสื่อม:</span>
                                <span className="text-info font-weight-bold">{(deprPerKm + tirePerKm + servicePerKm).toFixed(2)} ฿</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span>💼 ค่าแรง & อื่นๆ:</span>
                                <span className="text-success font-weight-bold">{((trip.driverWage + totalTollFee + (fixedCostPerDay * 2)) / totalDistance || 0).toFixed(2)} ฿</span>
                            </div>
                        </div>
                        <div className="col-md-4 text-center bg-danger rounded p-4 shadow-sm">
                            <h5 className="mb-1">ต้นทุนจริงสุทธิ</h5>
                            <div className="display-3 font-weight-bold">{finalCostPerKm.toFixed(2)}</div>
                            <p className="mb-0 font-weight-bold">บาท ต่อ กิโลเมตร</p>
                        </div>
                    </div>
                </div>

                {/* --- ส่วนสำหรับพิมพ์ (Print Preview Area) --- */}
                <div className="print-only container-fluid mt-2 p-4">
                    {/* หัวเอกสาร: ปรับให้ดูเป็นทางการขึ้น */}
                    <div className="d-flex justify-content-between align-items-end mb-4 border-bottom border-dark pb-3">
                        <div>
                            <h1 className="font-weight-bold mb-1 text-dark" style={{ fontSize: '28px' }}>
                                ใบสรุปงานขนส่ง (Transport Summary)
                            </h1>
                            <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                                <i className="fas fa-check-circle mr-1"></i> ระบบบริหารจัดการ และ คำนวณราคาค่าบริการขนส่ง
                            </p>
                        </div>
                        <div className="text-right">
                            <h5 className="font-weight-bold mb-1">ต้นฉบับ / Original</h5>
                            <p className="mb-0 small">วันที่พิมพ์: {new Date().toLocaleString('th-TH', { 
                                year: 'numeric', month: 'long', day: 'numeric', 
                                hour: '2-digit', minute: '2-digit' 
                            })}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            {/* ตารางข้อมูล: ใช้ border-dark เพื่อให้เส้นชัดเมื่อพิมพ์ขาวดำ */}
                            <table className="table table-bordered border-dark" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th colSpan="4" className="py-3 font-weight-bold text-uppercase bg-light border-dark">
                                            <i className="fas fa-route mr-2"></i> 1. ข้อมูลการจองและเส้นทาง (Booking & Route)
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td width="20%" className="font-weight-bold bg-light border-dark">จุดเริ่มต้น:</td>
                                        <td width="30%" className="border-dark">{bookingInfo.origin || '-'}</td>
                                        <td width="20%" className="font-weight-bold bg-light border-dark">ปลายทาง:</td>
                                        <td width="30%" className="border-dark">{bookingInfo.destination || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-weight-bold bg-light border-dark">เริ่มเดินทาง:</td>
                                        <td className="border-dark">{bookingInfo.startDate ? new Date(bookingInfo.startDate).toLocaleString('th-TH') : '-'}</td>
                                        <td className="font-weight-bold bg-light border-dark">สิ้นสุดงาน:</td>
                                        <td className="border-dark">{bookingInfo.endDate ? new Date(bookingInfo.endDate).toLocaleString('th-TH') : '-'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-weight-bold bg-light border-dark">ระยะทาง:</td>
                                        <td className="border-dark font-weight-bold text-primary">{trip.distance} กิโลเมตร</td>
                                        
                                    </tr>
                                </tbody>

                                <thead>
                                    <tr>
                                        <th colSpan="4" className="py-3 font-weight-bold text-uppercase bg-light border-dark">
                                            <i className="fas fa-users mr-2"></i> 2. ข้อมูลติดต่อ (Contact Information)
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="font-weight-bold bg-light border-dark">ชื่อลูกค้า:</td>
                                        <td className="border-dark">{bookingInfo.customerName || '-'}</td>
                                        <td className="font-weight-bold bg-light border-dark">เบอร์โทรศัพท์:</td>
                                        <td className="border-dark font-weight-bold">{bookingInfo.customerPhone || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-weight-bold bg-light border-dark">ชื่อผู้ขับรถ:</td>
                                        <td className="border-dark">{bookingInfo.driverName || '-'}</td>
                                        <td className="font-weight-bold bg-light border-dark">เบอร์โทรศัพท์:</td>
                                        <td className="border-dark">{bookingInfo.driverPhone || '-'}</td>
                                    </tr>
                                </tbody>

                                <thead>
                                    <tr>
                                        <th colSpan="4" className="py-3 font-weight-bold text-uppercase bg-light border-dark">
                                            <i className="fas fa-calculator mr-2"></i> 3. สรุปค่าบริการสุทธิ (Service Fee Summary)
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="font-weight-bold bg-light border-dark align-middle text-center" style={{ fontSize: '1.1rem' }}>
                                            ราคาค่าบริการ:
                                        </td>
                                        <td colSpan="3" className="py-4 border-dark text-center">
                                            <span className="h2 font-weight-bold mb-0">
                                                {bookingInfo.customerPrice ? Number(bookingInfo.customerPrice).toLocaleString() : '0'}
                                            </span>
                                            <span className="h4 ml-2">บาท (THB)</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="font-weight-bold bg-light border-dark">หมายเหตุ:</td>
                                        <td colSpan="3" className="py-3 border-dark text-muted">
                                            {bookingInfo.note || 'ไม่มีหมายเหตุเพิ่มเติม'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            {/* ฝั่ง QR Code */}
                            <div className="text-center pl-4">
                                {/* แทนที่ src ด้วย URL QR Code จริงของคุณ หรือ Prompt Pay */}
                                <img 
                                    src={`https://api.qrserver.com/v1/create-qr-code/?size=80x80&data=YOUR_PAYMENT_LINK_OR_TEXT`} 
                                    alt="QR Code"
                                    style={{ width: '80px', height: '80px', border: '1px solid #eee' }}
                                />
                                <p className="mb-0 font-weight-bold mt-1" style={{ fontSize: '9px' }}>สแกนเพื่อตรวจสอบ/ชำระเงิน</p>
                            </div>
                            {/* ส่วนท้าย: การลงนาม ปรับปรุงดีไซน์ให้สมดุล */}
                            {/* <div className="mt-5 pt-4">
                                <div className="row text-center">
                                    <div className="col-4">
                                        <div className="mb-4" style={{ height: '60px' }}></div>
                                        <div className="border-bottom border-dark w-75 mx-auto"></div>
                                        <p className="mt-2 font-weight-bold small">ผู้จัดทำ/พนักงานขับรถ</p>
                                        <p className="small">วันที่: ____/____/____</p>
                                    </div>
                                    <div className="col-4">
                                        <div className="mb-4" style={{ height: '60px' }}></div>
                                        <div className="border-bottom border-dark w-75 mx-auto"></div>
                                        <p className="mt-2 font-weight-bold small">ผู้รับสินค้า/ลูกค้า</p>
                                        <p className="small">วันที่: ____/____/____</p>
                                    </div>
                                    <div className="col-4">
                                        <div className="mb-4" style={{ height: '60px' }}></div>
                                        <div className="border-bottom border-dark w-75 mx-auto"></div>
                                        <p className="mt-2 font-weight-bold small">ผู้อนุมัติ (Authorized Sign)</p>
                                        <p className="small">วันที่: ____/____/____</p>
                                    </div>
                                </div>
                            </div> */}

                            {/* ข้อความ Footer เล็กๆ สำหรับเอกสาร */}
                            {/* <div className="mt-5 text-center text-muted border-top pt-3">
                                <p className="small">ขอบคุณที่ใช้บริการ — ความพึงพอใจของท่านคือบริการของเรา</p>
                            </div> */}
                        </div>
                    </div>
                </div>
        </main>
    )
}

export default Content